const WsAnalyticsDirective = {
  update: bind,
  inserted: bind
};
function bind(el, binding) {
  var _a;
  if (!window.ws_analytics) {
    return null;
  }
  if (!el.getAttribute("data-tracking")) {
    el.setAttribute("data-tracking", binding.value);
  }
  if ((_a = window.ws_analytics.stored) == null ? void 0 : _a[binding.value]) {
    Object.keys(window.ws_analytics.stored[binding.value]).forEach((key) => {
      el.addEventListener(key, window.ws_analytics.stored[binding.value][key]);
    });
    delete window.ws_analytics.stored[binding.value];
  }
}
export {
  WsAnalyticsDirective,
  bind
};
//# sourceMappingURL=wsAnalytics.es.js.map
